$(document).ready(function () {

    const img = document.querySelectorAll('.img-books')
    const authors = document.querySelectorAll('.img-author')
    function interception(entries, observer) {
        entries.forEach(entry => {
            if (entry.target.classList.contains('img-books')) {
                if (entry.isIntersecting) {
                    entry.target.src = entry.target.dataset.src;
                    observer.unobserve(entry.target);
                }
            }

            if (entry.target.classList.contains('img-author')) {
                if (entry.isIntersecting) {
                    entry.target.src = entry.target.dataset.src;
                    observer.unobserve(entry.target);
                }
            }
        });
    }


    const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    }

    const observer = new IntersectionObserver(interception,options);

    img.forEach(i => {
        observer.observe(i)
    })

    authors.forEach(i => {
        observer.observe(i)
    })


});
